import React from 'react';
import styles from './styles.mod.scss';

class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { now: new Date(), expired: false };
  }

  componentDidMount() {
    this.timer = setInterval(this.update.bind(this), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  update() {
    const now = new Date();
    if (now > this.props.expiresAt) {
      clearInterval(this.timer);
      this.setState({ expired: true });
      if (this.props.handleExpired) this.props.handleExpired();
      return;
    }
    this.setState({ now: new Date() });
  }

  display(ms) {
    const minutes = Math.floor(ms / (60 * 1000));
    const remainder = ms - minutes * 60 * 1000;
    const seconds = Math.floor(remainder / 1000);
    return {
      minutes: this.digitString(minutes),
      seconds: this.digitString(seconds)
    };
  }

  digitString(n) {
    if (isNaN(n)) return '00';
    const string = n.toString();
    return string.length < 2 ? `0${string}` : string;
  }

  render() {
    const diff = this.props.expiresAt - this.state.now;
    const { minutes, seconds } = this.display(diff);
    return (
      <div className={styles.timer}>
        <span>{minutes.charAt(0)}</span>
        <span>{minutes.charAt(1)}</span>
        {':'}
        <span>{seconds.charAt(0)}</span>
        <span>{seconds.charAt(1)}</span>
      </div>
    );
  }
}

export default Timer;
